module.exports = __webpack_public_path__ + "img/research_iton_6.2df1cced.png";